import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";

export default function ListStatus({ state }: { state: number }) {
    if (state === 0) {
        return (
            <div className={classNames(style.root, style.state)}>未开始</div>
        );
    }
    if (state === 1) {
        return (
            <div className={classNames(style.root, style.doing)}>进行中</div>
        );
    }
    if (state === 2) {
        return <div className={classNames(style.root, style.done)}>已结束</div>;
    }

    return (
        <div className={classNames(style.root, style.empty)}>
            【未添加题目】
        </div>
    );
}
